import { render, staticRenderFns } from "./EmailDetail.vue?vue&type=template&id=1eaead81&scoped=true&"
import script from "./EmailDetail.vue?vue&type=script&lang=js&"
export * from "./EmailDetail.vue?vue&type=script&lang=js&"
import style0 from "./EmailDetail.vue?vue&type=style&index=0&id=1eaead81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaead81",
  null
  
)

export default component.exports